import * as React from "react";
import { ExternalLink } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardFooter } from "@/components/ui/card";
const products = [{
  id: 1,
  name: "Woven Seagrass Baskets",
  category: "Storage",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1573125/img/woven_seagrass_baskets.png",
  url: "#"
}, {
  id: 2,
  name: "Glass Pantry Jars",
  category: "Kitchen",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1573125/img/glass_pantry_jars.png",
  url: "#"
}, {
  id: 3,
  name: "Minimalist Label Maker",
  category: "Organization",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1573125/img/minimalist_label_maker.png",
  url: "#"
}, {
  id: 4,
  name: "Linen Closet Bins",
  category: "Storage",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1573125/img/linen_closet_bins.png",
  url: "#"
}, {
  id: 5,
  name: "Bamboo Drawer Dividers",
  category: "Kitchen",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1573125/img/bamboo_drawer_dividers.png",
  url: "#"
}, {
  id: 6,
  name: "Utility Cleaning Caddy",
  category: "Cleaning",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1573125/img/utility_cleaning_caddy.png",
  url: "#"
}, {
  id: 7,
  name: "Clear Stackable Drawers",
  category: "Bathroom",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1573125/img/clear_stackable_drawers.png",
  url: "#"
}, {
  id: 8,
  name: "Ceramic Vanity Tray",
  category: "Decor",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1573125/img/ceramic_vanity_tray.png",
  url: "#"
}];
export default function ShopOurFavorites() {
  return <section id="shop-our-favorites" className="bg-background py-24 sm:py-32">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mb-16 text-center max-w-2xl mx-auto">
          <h2 className="font-serif text-4xl md:text-5xl text-foreground mb-4 tracking-tight">
            Shop Our Favorites
          </h2>
          <p className="text-muted-foreground text-lg font-light leading-relaxed">
            A curated selection of storage essentials and organization tools we use to create calm, functional spaces.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-x-6 gap-y-10">
          {products.map((product, i) => <Card key={product.id} data-index={i} className="group border-none shadow-none bg-transparent rounded-none overflow-visible">
              <CardContent className="p-0 relative mb-4 overflow-hidden bg-secondary/20 aspect-[4/5]">
                <img src={product.image} alt={product.name} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
                <div className="absolute inset-0 bg-black/0 group-hover:bg-black/5 transition-colors duration-500" />
              </CardContent>
              
              <CardFooter className="p-0 flex flex-col items-start gap-2">
                <span className="text-xs font-medium tracking-widest uppercase text-muted-foreground">
                  {product.category}
                </span>
                <h3 className="font-serif text-xl text-foreground group-hover:text-primary transition-colors duration-300">
                  {product.name}
                </h3>
                <Button asChild variant="link" className="h-auto p-0 text-sm font-medium text-foreground/80 hover:text-primary hover:no-underline group/btn mt-1">
                  <Link to={product.url} newTab>
                    Shop on Amazon
                    <ExternalLink className="ml-1 h-3 w-3 opacity-50 transition-transform group-hover/btn:-translate-y-0.5 group-hover/btn:translate-x-0.5" />
                  </Link>
                </Button>
              </CardFooter>
            </Card>)}
        </div>

        <div className="mt-16 text-center">
          <Button asChild variant="outline" className="rounded-full px-8 border-foreground/20 hover:bg-foreground hover:text-background transition-all duration-300">
            <Link to="/Resources">
              View All Recommendations
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}